export default {"src":"/_next/static/media/lambda-functions.ce6abe69.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};